import { useSelector } from "react-redux";

import BookWorkbookPage from "./book/BookWorkbookPage";
import PaperCropPage from "../readers_book/PaperCropPage";
import DeprecatedComprehensivePage from "./deprecated/DeprecatedComprehensivePage";
import OXPage from "./OX/OXPage";
import ScramblePage from "./scramble/ScramblePage";
import SummaryBlankPage from "./summary/SummaryBlankPage";
import TranslationPage from "./translation/TranslationPage";
import UnderstandingTestPage from "./understanding/UnderstandingTestPage";
import VocabularyPage from "./vocabulary/VocabularyPage";

const ComprehensivePage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  // 원서 워크북(지인에듀 mode=book). 세트 하나가 섹션 하나다.
  // 좌표가 실린 원서 세트는 쪽 위에서 바로 푼다(api/assignment/paper_pages.py). 쪽을 화면 크기만큼 잘라 보여 준다.
  if (section.type === "book" && (section.question?.pages || []).length > 0) {
    return <PaperCropPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} />;
  }

  if (section.type === "book") {
    return (
      <BookWorkbookPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  if (section.type === "comprehensive") {
    return (
      <DeprecatedComprehensivePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "ox_kor",
      "ox_kor_high",
      "ox_eng",
      "ox_eng_high",
      "ox"
    ].includes(section.type)
  ) {
    return (
      <OXPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "paraphrasing_scramble",
      "scramble"
    ].includes(section.type)
  ) {
    return (
      <ScramblePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "summary_blank_low",
      "summary_blank",
      "summary"
    ].includes(section.type)
  ) {
    return (
      <SummaryBlankPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "translation") {
    return (
      <TranslationPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "understanding_test",
      "understanding"
    ].includes(section.type)
  ) {
    return (
      <UnderstandingTestPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "keyword_meaning",
      "keyword"
    ].includes(section.type)
  ) {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "num_repeats") {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }
  return <div></div>;
};

export default ComprehensivePage;
